var map = {
	"./agentur_organisationsberatung_logo": 3,
	"./agentur_organisationsberatung_logo.png": 3,
	"./gboe_logo": 4,
	"./gboe_logo.png": 4,
	"./logo_evlka": 5,
	"./logo_evlka.png": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;